import React from 'react';
import moment from 'moment';
import upperFirst from 'lodash/upperFirst';

import {libraryShape} from 'components/Shapes';
import LibraryLink from 'components/pure/admin/LibraryLink';
import LibrarySettings from 'components/pure/admin/LibrarySettings';

export default class LibraryTableRow extends React.PureComponent {
  render() {
    const {library} = this.props;

    return (
      <tr>
        <td className="library-name">
          <LibraryLink {...{library}} />
        </td>
        <td className="created-by">{library.created_by}</td>
        <td className="calls">{library.calls_count}</td>
        <td className="last-modified">{moment(library.modified).format('MM/DD/YYYY')}</td>
        <td className="sharing">{upperFirst(library.shared_type)}</td>
        <td className="manage">
          <LibrarySettings {...{library}} />
        </td>
      </tr>
    );
  }
}

LibraryTableRow.propTypes = {
  library: libraryShape.isRequired,
};

LibraryTableRow.displayName = 'LibraryTableRow';
